/**
 *
 * @notice OrganicoSlice to handle state of Organico globally.
 *
 * @dev This module contains the slice reducer configuration 
 * @dev and its initialization.
 * @dev Is the controller wich contains features of this slice.
 *
 */
// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import {
    API_KEY,
    listaLavoratoriAPI,
    informazioniLavoratoreAPI,
    downloadFotoLavoratoreAPI,
    corsiLavoratoreAPI,
    eliminaCorsoLavoratoreAPI,
    visiteLavoratoreAPI,
    eliminaVisiteLavoratoreAPI,
    documentiLavoratoreAPI,
    downloadCorsoLavoratoreAPI,
    caricaFotoLavoratoreAPI,
    downloadVisitaLavoratoreAPI,
    scaricaDocumentoLavoratoreAPI,
    //downloadAllCorsiLavoratoreAPI
    downloadOrganicoAPI,
    downloadLavoratoreAPI, downloadCorsiLavoratoreAPI, downloadDocumentiLavoratoreAPI, downloadVisiteLavoratoreAPI
} from "../../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../../common/cookie"
// util.
import { downloadDocument, showDocument } from "../../../../common/util"
/********************************************
 *                                          *
 * @notice AsyncThunk API(s) Implementation *
 *                                          *
 ********************************************/
/**
 *
 * @dev Get Organico data.
 *
 */
export const getOrganico = createAsyncThunk(
    // Action route.
    "organico/getOrganico",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                listaLavoratoriAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getOrganico":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Upload Employee logo.
 *
 */
export const uploadEmployeeLogo = createAsyncThunk(
    // Action route.
    "organico/uploadEmployeeLogo",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { any } newLogo
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ newLogo, id }, thunkAPI) => {
        try {
            var bodyFormData = new FormData()
            bodyFormData.append('allegato', newLogo, newLogo.name)

            const response = await axios.post(
                // url.
                caricaFotoLavoratoreAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    headers: { "Content-Type": "multipart/form-data" },
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: id
                    },
                },
            )
            //
            //
            //
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response
                } else {
                    console.error('Error "uploadEmployeeLogo":', response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                console.error('Error "uploadEmployeeLogo":', response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "uploadEmployeeLogo":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get Employee img by id.
 *
 */
export const getEmployeeImgById = createAsyncThunk(
    // Action route.
    "organico/getEmployeeImgById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } employeeId
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (employeeId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadFotoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: employeeId,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getEmployeeImgById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getEmployeeImgById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getEmployeeImgById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get employee info by id.
 *
 */
export const getEmployeeInfoById = createAsyncThunk(
    // Action route.
    "organico/getEmployeeInfoId",
    /**
      * 
      * @dev Async Function with axios http req.
      * 
      * @param { string } employeeId
      * 
      * @param { AsyncThunkPayloadCreator } thunkAPI
      * @dev `thunkAPI` callback function that should return a promise
      * @dev handle with extraReducers to update the State.
      * @dev It takes two parameter too: first is the value of the dispatched action,
      * @dev and the second is the Thunk API config.
      * 
      * @returns AsyncThunk
      * 
      */
    async (employeeId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                informazioniLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: employeeId,
                    },
                }
            )

            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getEmployeeInfoById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getEmployeeInfoById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)

            }
        } catch (error) {
            console.error('Error "getEmployeeInfoById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get employee courses by id.
 *
 */
export const getEmployeeCoursesById = createAsyncThunk(
    // Action route.
    "organico/getEmployeeCoursesById",
    /**
      * 
      * @dev Async Function with axios http req.
      * 
      * @param { string } employeeId
      * 
      * @param { AsyncThunkPayloadCreator } thunkAPI
      * @dev `thunkAPI` callback function that should return a promise
      * @dev handle with extraReducers to update the State.
      * @dev It takes two parameter too: first is the value of the dispatched action,
      * @dev and the second is the Thunk API config.
      * 
      * @returns AsyncThunk
      * 
      */
    async (employeeId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                corsiLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: employeeId,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getEmployeeCoursesById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getEmployeeCoursesById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getEmployeeCoursesById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get employee docs by id.
 *
 */
export const deleteEmployeeCourseDocById = createAsyncThunk(
    // Action route.
    "organico/deleteEmployeeCourseDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxLavoratori
     * @param { string } obj.idBoxCorsiLavoratore
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxLavoratori, idBoxCorsiLavoratore }, thunkAPI) => {
        try {
            const response = await axios.delete(
                // url.
                eliminaCorsoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: idBoxLavoratori,
                        id_box_documenti_lavoratore: idBoxCorsiLavoratore,

                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxCorsiLavoratore,
                    }
                } else {
                    //console.error('Error "deleteEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "deleteEmployeeCourseDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "deleteEmployeeCourseDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get employee exams by id.
 *
 */
export const getEmployeeExamsById = createAsyncThunk(
    // Action route.
    "organico/getEmployeeExamsById",
    /**
      * 
      * @dev Async Function with axios http req.
      * 
      * @param { string } employeeId
      * 
      * @param { AsyncThunkPayloadCreator } thunkAPI
      * @dev `thunkAPI` callback function that should return a promise
      * @dev handle with extraReducers to update the State.
      * @dev It takes two parameter too: first is the value of the dispatched action,
      * @dev and the second is the Thunk API config.
      * 
      * @returns AsyncThunk
      * 
      */
    async (employeeId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                visiteLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: employeeId,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getEmployeeExamsById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getEmployeeExamsById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getEmployeeExamsById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Delete Employee exam by id.
 *
 */
export const deleteEmployeeExamById = createAsyncThunk(
    // Action route.
    "organico/deleteEmployeeExamById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxLavoratori
     * @param { string } obj.idBoxVisitaLavoratore
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxLavoratori, idBoxVisitaLavoratore }, thunkAPI) => {
        try {
            const response = await axios.delete(
                // url.
                eliminaVisiteLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: idBoxLavoratori,
                        id_box_visite_lavoratore: idBoxVisitaLavoratore,

                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxVisitaLavoratore,
                    }
                } else {
                    //console.error('Error "deleteEmployeeExamById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "deleteEmployeeExamById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "deleteEmployeeExamById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Get employee docs by id.
 *
 */
export const getEmployeeDocsById = createAsyncThunk(
    // Action route.
    "organico/getEmployeeDocsById",
    /**
      * 
      * @dev Async Function with axios http req.
      * 
      * @param { string } employeeId
      * 
      * @param { AsyncThunkPayloadCreator } thunkAPI
      * @dev `thunkAPI` callback function that should return a promise
      * @dev handle with extraReducers to update the State.
      * @dev It takes two parameter too: first is the value of the dispatched action,
      * @dev and the second is the Thunk API config.
      * 
      * @returns AsyncThunk
      * 
      */
    async (employeeId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                documentiLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: employeeId,
                    },
                }
            )

            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getEmployeeDocsById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getEmployeeDocsById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getEmployeeDocsById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Delete employee docs by id.
 *
 */
export const deleteEmployeeDocById = createAsyncThunk(
    // Action route.
    "organico/deleteEmployeeDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxLavoratori
     * @param { string } obj.idBoxDocumentiLavoratore
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxLavoratori, idBoxDocumentiLavoratore }, thunkAPI) => {
        try {
            const response = await axios.delete(
                // url.
                eliminaCorsoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_lavoratori: idBoxLavoratori,
                        id_box_documenti_lavoratore: idBoxDocumentiLavoratore,

                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxDocumentiLavoratore,
                    }
                } else {
                    //console.error('Error "deleteEmployeeDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "deleteEmployeeDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "deleteEmployeeDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Show Employee doc by id.
 *
 */
export const showEmployeeDocById = createAsyncThunk(
    // Action route.
    "organico/showEmployeeDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxDocumentiLavoratore
     * @param { string } obj.docName
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (idBoxDocumentiLavoratore, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                scaricaDocumentoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_documenti_lavoratore: idBoxDocumentiLavoratore,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return response
                } else {
                    //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeCourseDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Download Employee doc by id.
 *
 */
export const downloadEmployeeDocById = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } idBoxDocumentiLavoratore
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxDocumentiLavoratore, docName }, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                scaricaDocumentoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_documenti_lavoratore: idBoxDocumentiLavoratore,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return response
                } else {
                    //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeCourseDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Download Employee course doc by id.
 *
 */
export const downloadEmployeeCourseDocById = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeCourseDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxCorsiLavoratore
     * @param { string } obj.docName
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxCorsiLavoratore, docName }, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadCorsoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_corsi_lavoratore: idBoxCorsiLavoratore,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxCorsiLavoratore,
                    }
                } else {
                    //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadEmployeeCourseDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeCourseDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Show Employee course doc by id.
 *
 */
export const showEmployeeCourseDocById = createAsyncThunk(
    // Action route.
    "organico/showEmployeeCourseDocById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } idBoxCorsiLavoratore
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (idBoxCorsiLavoratore, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadCorsoLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_corsi_lavoratore: idBoxCorsiLavoratore,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxCorsiLavoratore,
                    }
                } else {
                    //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "showEmployeeCourseDocById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "showEmployeeCourseDocById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/**
 *
 *  @dev Download Employee Exam by id.
 *
 */
export const downloadEmployeeExamById = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeExamById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { Object } obj
     * @param { string } obj.idBoxVisitaLavoratore
     * @param { string } obj.docName
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ idBoxVisitaLavoratore, docName }, thunkAPI) => {
        try {
            const response = await axios.get(
                downloadVisitaLavoratoreAPI,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_visite_lavoratore: idBoxVisitaLavoratore,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    // Build a custom response with extradata.
                    return {
                        data: response.data,
                        eventSender: idBoxVisitaLavoratore,
                    }
                } else {
                    //console.error('Error "downloadEmployeeExamById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadEmployeeExamById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeExamById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Get Employee details by id.
 *
 */
export const downloadEmployeeDetails = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeDetails",
    async ({ lavoratoreId }, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id: lavoratoreId
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "downloadOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeDetails":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

function getEscapedLavoratoreFullname() {
    let element = document.querySelectorAll("a[href='/dashboard/lavoratori/dettaglio-lavoratore-127']")
    if (element.length == 0) {
        return 'lavoratore';
    }
    return element[0]
        .text
        .toLowerCase()
        .replaceAll(' ', '_');
}

export const downloadEmployeeCourses = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeCourses",
    async ({ lavoratoreId }, thunkAPI) => {
        try {
            console.log('DOWNLOAD COURSES: ', lavoratoreId);

            const response = await axios.get(
                // url.
                downloadCorsiLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id: lavoratoreId
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "downloadOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeCourses":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

export const downloadEmployeeMedicalCheckups = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeMedicalCheckups",
    async ({ lavoratoreId }, thunkAPI) => {
        try {
            console.log('DOWNLOAD MEDICAL CHECKUPS', lavoratoreId);

            const response = await axios.get(
                // url.
                downloadVisiteLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id: lavoratoreId
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "downloadOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeMedicalCheckups":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

export const downloadEmployeeDocuments = createAsyncThunk(
    // Action route.
    "organico/downloadEmployeeDocuments",
    async ({ lavoratoreId }, thunkAPI) => {
        try {
            console.log('DOWNLOAD DOCUMENTS', lavoratoreId);

            const response = await axios.get(
                // url.
                downloadDocumentiLavoratoreAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id: lavoratoreId
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "downloadOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadEmployeeDocuments":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)



/**
 *
 *  @dev Get Employee img by id.
 *
 */
export const downloadOrganico = createAsyncThunk(
    // Action route.
    "organico/downloadOrganico",
    async ({ }, thunkAPI) => {
        console.log('downloadOrganico')
        try {
            const response = await axios.get(
                // url.
                downloadOrganicoAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "downloadOrganico":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "downloadOrganico":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "downloadOrganico":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)
/******************************************
 *                                        *
 * @notice createSlice implementation.    *
 *                                        *
 * @dev Create a "organicoSlice" feature. *
 * @dev UI views state controller.        *
 *                                        *
 ******************************************/
export const organicoSlice = createSlice({
    // Name, used in action types.
    name: "organico",
    // The initial state for the reducer.
    initialState: {
        organicoItems: [],             // All organico items.
        //needsReload: false,            // Does Component view needs reload (fire useEffects).
        employeeImg: "",               // Employee img.
        employeeInfo: [],              // Employee info.
        employeeCourses: [],           // All Courses of an employee.
        employeeExams: [],             // All Exams of an employee.
        employeeDocs: [],              // All Documents of an employee.
        defaultTabIndex: 0,            // Default tab index of "Tabs" child component.
        isFetching: false,             // AsyncThunk is calling an API.
        isSuccess: false,              // AsyncThunk is success from API call.
        isError: false,                // AsyncThunk is fail from API call.
        errorMsg: "",                  // Error message container.
        // Employee doc.
        employeeDoc: [],               // Eemployee document.
        employeeDocName: "",           // Eemployee document name.
        employeeDocSenderId: "",
        isFetchingDoc: false,
        isSuccessDoc: false,
        isErrorDoc: false,
        errorMsgDoc: "",
        // Employee course.
        employeeCourseDoc: [],         // Course Document of an employee.
        employeeCourseDocName: "",     // Course Document Name.
        employeeCourseDocSenderId: "", // Employee id of a Course Document.
        isFetchingCourseDoc: false,
        isSuccessCourseDoc: false,
        isErrorCourseDoc: false,
        errorMsgCourseDoc: "",
        // Employee exam.
        employeeExam: [],         // Exam of an employee.
        employeeExamName: "",     // Exam Document Name.
        employeeExamSenderId: "", // Employee id of a Course Document.
        isFetchingExam: false,
        isSuccessExam: false,
        isErrorExam: false,
        errorMsgExam: "",
        // Employee List.
        employeeList: [],
        employeeListName: "",
        employeeListSenderId: "",
        isFetchingList: false,
        isSuccessList: false,
        isErrorList: false,
        errorMsgList: "",
        // Employee Details.
        employeeDetails: [],
    },
    // Reducers, an object of "case reducers".
    // Key names will be used to generate actions.
    reducers: {
        cleanUpEmployeeInfo: (state) => {
            state.employeeInfo = []

            return state
        },
        cleanUpEmployeeCourses: (state) => {
            state.employeeCourses = []
            return state
        },
        cleanUpEmployeeExams: (state) => {
            state.employeeExams = []

            return state
        },
        cleanUpEmployeeDocs: (state) => {
            state.employeeDocs = []

            return state
        },
        clearEmployeeCourseDocSenderId: (state) => {
            state.employeeCourseDocSenderId = ""

            return state
        },
        clearEmployeeExamSenderId: (state) => {
            state.employeeExamSenderId = ""

            return state
        },
        clearEmployeeDocSenderId: (state) => {
            state.employeeDocSenderId = ""

            return state
        },
    },
    // AsyncThunk Reducers.
    // A "builder callback" function used to add more reducers, or
    // an additional object of "case reducers", where the keys should be other
    // action types.
    extraReducers: (builder) => {
        builder
            /*******************************************************************
             *
             * @dev getOrganico.
             *
             */
            .addCase(getOrganico.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true

                const organicoList = action.payload.gmapi.response.data
                //
                // Sort asc the organico list items by `cognome`prop,
                // then sort again by `attivo` prop.
                //
                state.organicoItems = organicoList.sort((firstEl, secondEl) => (
                    firstEl["cognome"] < secondEl["cognome"] ? 1 : -1
                )).sort((firstEl, secondEl) => (
                    firstEl["attivo"] < secondEl["attivo"] ? 1 : -1
                ))

            })
            .addCase(getOrganico.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getOrganico.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev uploadEmployeeLogo.
             *
             */
            .addCase(uploadEmployeeLogo.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.employeeImg = action.payload.data.gmapi.response.data
            })
            .addCase(uploadEmployeeLogo.pending, (state) => {
                state.isFetching = true
            })
            .addCase(uploadEmployeeLogo.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getEmployeeImgById.
             *
             */
            .addCase(getEmployeeImgById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.employeeImg = action.payload.gmapi.response.data

                // Handle empty image data.
                /*
                switch (action.payload.gmapi.response.data) {
                    case "data:directory;base64,":
                        state.employeeImg = "data:image/png;base64,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"
                        break
                    default:
                        state.employeeImg = action.payload.gmapi.response.data
                        break
                }
                */
            })
            .addCase(getEmployeeImgById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getEmployeeImgById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getEmployeeInfoById.
             *
             */
            .addCase(getEmployeeInfoById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.employeeInfo = action.payload.gmapi.response.data[0]
            })
            .addCase(getEmployeeInfoById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getEmployeeInfoById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getEmployeeCoursesById.
             *
             */
            .addCase(getEmployeeCoursesById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                //state.needsReload = false // Component view doesn't needs refresh.

                // Update employeeCourses sort by `data_ora_inserimento` key.
                const employeeCourses = action.payload.gmapi.response.data
                state.employeeCourses = employeeCourses.sort((firstEl, secondEl) => (
                    firstEl["data_ora_inserimento"] < secondEl["data_ora_inserimento"] ? 1 : -1
                ))
            })
            .addCase(getEmployeeCoursesById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getEmployeeCoursesById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             * 
             * @dev deleteEmployeeCourseDocById.
             * 
             */
            .addCase(deleteEmployeeCourseDocById.fulfilled, (state, action) => {
                //state.isFetching = false
                //state.isSuccess = true
                //state.needsReload = true // Component view needs refresh.

                // Get the eventSender from the action payload.
                const idBoxCorsiLavoratore = action.payload.eventSender
                // Find the object wich corresponding id.
                const courseToRemove = state.employeeCourses.findIndex((obj) => obj.id_box_corsi_lavoratore === idBoxCorsiLavoratore)

                // If found then remove it from the list.
                if (courseToRemove > -1) {
                    state.employeeCourses.splice(courseToRemove, 1) // Remove the item selected.
                }

                state.defaultTabIndex = 1 // Tab: "Corsi".
            })
            .addCase(deleteEmployeeCourseDocById.pending, (state) => {
                //state.isFetching = true
            })
            .addCase(deleteEmployeeCourseDocById.rejected, (state, action) => {
                //state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
                //state.needsReload = true
            })
            /*******************************************************************
             * 
             * @dev getEmployeeExamsById.
             * 
             */
            .addCase(getEmployeeExamsById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true

                // Update employeeExams sort by `data_ora_inserimento` key.
                const employeeExams = action.payload.gmapi.response.data
                state.employeeExams = employeeExams.sort((firstEl, secondEl) => (
                    firstEl["data_ora_inserimento"] < secondEl["data_ora_inserimento"] ? 1 : -1
                ))
            })
            .addCase(getEmployeeExamsById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getEmployeeExamsById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             * 
             * @dev deleteEmployeeExamById.
             * 
             */
            .addCase(deleteEmployeeExamById.fulfilled, (state, action) => {
                //state.isFetching = false
                //state.isSuccess = true
                //state.needsReload = true // Component view needs refresh.

                // Get the eventSender from the action payload.
                const idBoxVisitaLavoratore = action.payload.eventSender
                // Find the object wich corresponding id.
                const examToRemove = state.employeeExams.findIndex((obj) => obj.id_box_visite_lavoratore === idBoxVisitaLavoratore)

                // If found then remove it from the list.
                if (examToRemove > -1) {
                    state.employeeExams.splice(examToRemove, 1) // Remove the item selected.
                }

                state.defaultTabIndex = 2  // Tab: "Visite".

            })
            .addCase(deleteEmployeeExamById.pending, (state) => {
                //state.isFetching = true
            })
            .addCase(deleteEmployeeExamById.rejected, (state, action) => {
                //state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
                //state.needsReload = true
            })
            /*******************************************************************
             * 
             * @dev getEmployeeDocsById.
             * 
             */
            .addCase(getEmployeeDocsById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true

                // Update employeeDocs sort by `data_ora_inserimento` key.
                const employeeDocs = action.payload.gmapi.response.data
                state.employeeDocs = employeeDocs.sort((firstEl, secondEl) => (
                    firstEl["data_ora_inserimento"] < secondEl["data_ora_inserimento"] ? 1 : -1
                ))
            })
            .addCase(getEmployeeDocsById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getEmployeeDocsById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })

            /*******************************************************************
             * 
             * @dev deleteEmployeeDocById.
             * 
             */
            .addCase(deleteEmployeeDocById.fulfilled, (state, action) => {
                //state.isFetching = false
                //state.isSuccess = true
                //state.needsReload = true // Component view needs refresh.

                // Get the eventSender from the action payload.
                const idBoxDocumentiLavoratore = action.payload.eventSender
                // Find the object wich corresponding id.
                const documentToRemove = state.employeeDocs.findIndex((obj) => obj.id_box_documenti_lavoratore === idBoxDocumentiLavoratore)

                // If found then remove it from the list.
                if (documentToRemove > -1) {
                    state.employeeDocs.splice(documentToRemove, 1) // Remove the item selected.
                }

                state.defaultTabIndex = 3 // Tab: "Documenti".
            })
            .addCase(deleteEmployeeDocById.pending, (state) => {
                //state.isFetching = true
            })
            .addCase(deleteEmployeeDocById.rejected, (state, action) => {
                //state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
                //state.needsReload = true
            })
            /*******************************************************************
             *
             * @dev showEmployeeDocById.
             *
             */
            .addCase(showEmployeeDocById.fulfilled, (state, action) => {
                // Needless.
                //state.isFetchingDoc = false
                //state.isSuccessDoc = true

                // get the base64 string.
                state.employeeDoc = action.payload.data.gmapi.response.data
                // Get the file name.
                //state.noticeDocName = action.meta.arg

                showDocument(state.employeeDoc)
            })
            .addCase(showEmployeeDocById.pending, (state, action) => {
                // Needless.
                //state.isFetchingDoc = true
            })
            .addCase(showEmployeeDocById.rejected, (state, action) => {
                // Needless.
                //state.isFetchingDoc = false
                //state.isErrorDoc = true
                state.errorMsgDoc = action.payload
            })
            /*******************************************************************
             * 
             * @dev downloadEmployeeDocById.
             * 
             */
            .addCase(downloadEmployeeDocById.fulfilled, (state, action) => {
                state.isFetchingDoc = false
                state.isSuccessDoc = true

                // Update the state with the file name from action payload.
                state.employeeDoc = action.payload.data.gmapi.response.data
                // Update the state with the file name.
                state.employeeDocName = action.meta.arg.docName

                // Document download trigger.
                downloadDocument(state.employeeDoc, state.employeeDocName)
            })
            .addCase(downloadEmployeeDocById.pending, (state, action) => {
                state.isFetchingDoc = true
                // Update the state with doc id.
                state.employeeDocSenderId = action.meta.arg.idBoxDocumentiLavoratore
            })
            .addCase(downloadEmployeeDocById.rejected, (state, action) => {
                state.isFetchingDoc = false
                state.isErrorDoc = true
                state.errorMsgDoc = action.payload
            })
            /*******************************************************************
             * 
             * @dev downloadEmployeeCourseDocById.
             * 
             */
            .addCase(downloadEmployeeCourseDocById.fulfilled, (state, action) => {
                state.isFetchingCourseDoc = false
                state.isSuccessCourseDoc = true

                // Update the state with the file name from action payload.
                state.employeeCourseDoc = action.payload.data.gmapi.response.data
                // Update the state with the file name.
                state.employeeCourseDocName = action.meta.arg.docName

                // Document download trigger.
                downloadDocument(state.employeeCourseDoc, state.employeeCourseDocName)
            })
            .addCase(downloadEmployeeCourseDocById.pending, (state, action) => {
                state.isFetchingCourseDoc = true
                // Update the state with doc id.
                state.employeeCourseDocSenderId = action.meta.arg.idBoxCorsiLavoratore
            })
            .addCase(downloadEmployeeCourseDocById.rejected, (state, action) => {
                state.isFetchingCourseDoc = false
                state.isErrorCourseDoc = true
                //state.errorMsgCourseDoc = action.payload;
            })
            /*******************************************************************
             * 
             * @dev showEmployeeCourseDocById.
             * 
             */
            .addCase(showEmployeeCourseDocById.fulfilled, (state, action) => {
                //state.isFetchingCourseDoc = false;
                //state.isSuccessCourseDoc = true;

                // get the base64 string.
                state.employeeCourseDoc = action.payload.data.gmapi.response.data
                // Get the file name.
                //state.employeeCourseDocName = action.meta.arg

                showDocument(state.employeeCourseDoc)
            })
            .addCase(showEmployeeCourseDocById.pending, (state, action) => {
                //state.isFetchingCourseDoc = true;
                //state.employeeCourseDocSenderId = action.meta.arg; // Access to thunk argument passed in "showEmployeeCourseDocById" AsyncThunk.
            })
            .addCase(showEmployeeCourseDocById.rejected, (state, action) => {
                //state.isFetchingCourseDoc = false;
                //state.isErrorCourseDoc = true;
                //state.errorMsgCourseDoc = action.payload;
            })
            /*******************************************************************
             * 
             * @dev downloadEmployeeCourseDocById.
             * 
             */
            .addCase(downloadEmployeeExamById.fulfilled, (state, action) => {
                state.isFetchingExam = false
                state.isSuccessExam = true

                // Update the state with the file name from action payload.
                state.employeeExam = action.payload.data.gmapi.response.data
                // Update the state with the file name.
                state.employeeExamName = action.meta.arg.docName

                // Document download trigger.
                downloadDocument(state.employeeExam, state.employeeExamName)
            })
            .addCase(downloadEmployeeExamById.pending, (state, action) => {
                state.isFetchingExam = true
                // Update the state with doc id.
                state.employeeExamSenderId = action.meta.arg.idBoxVisitaLavoratore
            })
            .addCase(downloadEmployeeExamById.rejected, (state, action) => {
                state.isFetchingExam = false
                state.isErrorExam = true
                //state.errorMsgExam = action.payload;
            })
            /*******************************************************************
             * 
             * @dev downloadOrganico.
             * 
             */
            .addCase(downloadOrganico.fulfilled, (state, action) => {
                state.isFetchingList = false
                state.isSuccessList = true

                // Update the state with the file name from action payload.
                let employeeList = action.payload.gmapi.response.data
                let fileName = 'organicoaziendale_azienda.pdf';
                let splitted = employeeList.split("|");
                if (splitted.length > 1) {
                    fileName = splitted.shift() + '.pdf';
                    employeeList = splitted.join('|');
                }

                state.employeeList = employeeList
                // Update the state with the file name.
                state.employeeListName = action.meta.arg.docName

                // Document download trigger.
                downloadDocument(state.employeeList, fileName)
            })
            .addCase(downloadOrganico.pending, (state, action) => {
                state.isFetchingList = true
                // Update the state with doc id.
                state.employeeListSenderId = action.meta.arg.idBoxVisitaLavoratore
            })
            .addCase(downloadOrganico.rejected, (state, action) => {
                state.isFetchingList = false
                state.isErrorList = true
                //state.errorMsgList = action.payload;
            })
            /*******************************************************************
            * 
            * @dev downloadEmployeeDetails.
            * 
            */
            .addCase(downloadEmployeeDetails.fulfilled, (state, action) => {
                state.isFetchingList = false
                state.isSuccessList = true

                // Update the state with the file name from action payload.
                state.employeeDetails = action.payload.gmapi.response.data
                // console.log(state.employeeDetails);
                // Update the state with the file name.
                // state.employeeDetailsName = action.meta.arg.docName

                // Document download trigger.
                let name = document.querySelector('input[name=employee-name]') ? document.querySelector('input[name=employee-name]').value : '';
                let surname = document.querySelector('input[name=employee-surname]') ? document.querySelector('input[name=employee-surname]').value : '';
                downloadDocument(state.employeeDetails, 'tesserinoriconoscimento_' + name.toLowerCase() + '_' + surname.toLowerCase() + '.pdf')
            })
            .addCase(downloadEmployeeDetails.pending, (state, action) => {
                state.isFetchingList = true
                // Update the state with doc id.
                // state.employeeDetailsSenderId = action.meta.arg.idBoxVisitaLavoratore
            })
            .addCase(downloadEmployeeDetails.rejected, (state, action) => {
                state.isFetchingList = false
                state.isErrorList = true
                //state.errorMsgList = action.payload;
            })
            .addCase(downloadEmployeeCourses.fulfilled, (state, action) => {
                state.isFetchingList = false
                state.isSuccessList = true
                state.employeeDetails = action.payload.gmapi.response.data
                let name = document.querySelector('input[name=employee-name]') ? document.querySelector('input[name=employee-name]').value : '';
                let surname = document.querySelector('input[name=employee-surname]') ? document.querySelector('input[name=employee-surname]').value : '';
                downloadDocument(state.employeeDetails, 'corsi_' + getEscapedLavoratoreFullname() + '.pdf')
            })
            .addCase(downloadEmployeeCourses.pending, (state, action) => {
                state.isFetchingList = true
            })
            .addCase(downloadEmployeeCourses.rejected, (state, action) => {
                state.isFetchingList = false
                state.isErrorList = true
            })
            .addCase(downloadEmployeeMedicalCheckups.fulfilled, (state, action) => {
                state.isFetchingList = false
                state.isSuccessList = true
                state.employeeDetails = action.payload.gmapi.response.data
                let name = document.querySelector('input[name=employee-name]') ? document.querySelector('input[name=employee-name]').value : '';
                let surname = document.querySelector('input[name=employee-surname]') ? document.querySelector('input[name=employee-surname]').value : '';
                downloadDocument(state.employeeDetails, 'visite_' + getEscapedLavoratoreFullname() + '.pdf')
            })
            .addCase(downloadEmployeeMedicalCheckups.pending, (state, action) => {
                state.isFetchingList = true
            })
            .addCase(downloadEmployeeMedicalCheckups.rejected, (state, action) => {
                state.isFetchingList = false
                state.isErrorList = true
            })
            .addCase(downloadEmployeeDocuments.fulfilled, (state, action) => {
                state.isFetchingList = false
                state.isSuccessList = true
                state.employeeDetails = action.payload.gmapi.response.data
                let name = document.querySelector('input[name=employee-name]') ? document.querySelector('input[name=employee-name]').value : '';
                let surname = document.querySelector('input[name=employee-surname]') ? document.querySelector('input[name=employee-surname]').value : '';
                downloadDocument(state.employeeDetails, 'documenti_' + getEscapedLavoratoreFullname() + '.pdf')
            })
            .addCase(downloadEmployeeDocuments.pending, (state, action) => {
                state.isFetchingList = true
            })
            .addCase(downloadEmployeeDocuments.rejected, (state, action) => {
                state.isFetchingList = false
                state.isErrorList = true
            })







    },
})
// Export the reducer.
export const {
    cleanUpEmployeeInfo,
    cleanUpEmployeeCourses,
    cleanUpEmployeeExams,
    cleanUpEmployeeDocs,
    clearEmployeeCourseDocSenderId,
    clearEmployeeExamSenderId,
    clearEmployeeDocSenderId,
} = organicoSlice.actions
// Export the Slice by name.
export const organicoSelector = (state) => state.organico
